import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { Link, useRouteError } from 'react-router'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import useTranslator from '@/hooks/translation'

const ReactRouterErrorElement = () => {
  const error = useRouteError()
  const { getTranslation } = useTranslator()

  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background p-4">
      <Card className="flex w-full max-w-md flex-col items-center bg-card-opaque p-8 text-center">
        <CardHeader className="space-y-4 pb-6">
          <div className="mx-auto text-6xl font-bold text-muted-foreground">
            Ops...
          </div>
        </CardHeader>

        <CardContent className="space-y-6">
          <div className="space-y-2">
            <h1 className="text-2xl font-semibold text-foreground">
              {getTranslation('components.reactRouterErrorElement.title')}
            </h1>
            <p className="text-muted-foreground">
              {getTranslation('components.reactRouterErrorElement.description')}
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
            <Button asChild variant="fintalk">
              <Link to="/">
                {getTranslation(
                  'components.reactRouterErrorElement.backToHome',
                )}
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export { ReactRouterErrorElement }
